module.exports = __webpack_public_path__ + "static/media/Team 16 - Savage Not Average.58b6a563.png";